import React from "react";
import PageHeroSection from "../../components/ui/PageSections/PageHeroSection";
import EmpowerServicesSection from "../../components/ui/PageSections/EmpowerServicesSection";
import Section from "../../components/ui/Section";
import iconUltraproxy from "../../images/icons/icon-ultraproxy-gray.svg";
import TertiaryInputTable from "../../components/ui/InputTables/TertiaryInputTable";
import StyledTitle from "../../components/ui/StyledTitle";
import imageUltraproxy from "../../images/image-ultraproxy.svg";
import PresenceBanner from "../../components/ui/PageSections/PresenceBanner";
import ContactUsBanner from "../../components/ui/PageSections/ContactUsBanner";

const howItWorksInfo = [
	{
		id: "1",
		title: "UltraproxyHowItWorksTitleOne",
		description1: "UltraproxyHowItWorksTitleOne_One",
	},
	{
		id: "2",
		title: "UltraproxyHowItWorksTitleTwo",
		description1: "UltraproxyHowItWorksTitleTwo_One",
		description2: "UltraproxyHowItWorksTitleTwo_Two",
	},
	{
		id: "3",
		title: "UltraproxyHowItWorksTitleThree",
		description1: "UltraproxyHowItWorksTitleThree_One",
		description2: "UltraproxyHowItWorksTitleThree_Two",
	},
];

const UltraproxyPageTemplate = ({ pageContext, translations }) => {
	return (
		<div id="UltraproxyInputSection">
			<PageHeroSection
				heroTitle={
					translations["UltraproxyMainTitle"] ? translations["UltraproxyMainTitle"] : pageContext.h1Title
				}
				heroIcon={iconUltraproxy}
				heroIconAltText="White rombus rack icon"
				subtitle={translations["UltraproxySubtitle"] ? translations["UltraproxySubtitle"] : pageContext.h2Title}
				intro={translations["UltraproxyIntro"]}
			/>
			<TertiaryInputTable
				serviceType="ultraproxy"
				defaultIataCode={pageContext.iataCode}
				translations={translations}
				pageContext={pageContext}
				featureList={["Local IP", "100 Gb transfer", "Extra Transfer 0.5 USD per GB"]}
			/>
			<Section color="white" skewed="bottom">
				<HowItWorksSection translations={translations} />
			</Section>
			<Section color="transparent">
				<EmpowerServicesSection translations={translations} />
			</Section>
			<Section color="white">
				<PresenceBanner translations={translations} />
			</Section>
			<Section color="transparent">
				<ContactUsBanner
					title={translations["UltraproxyContactUsBannerTitle"]}
					subtitle={translations["UltraproxyContactUsBannerSubtitle"]}
					contactText={translations["contact"]}
				/>
			</Section>
		</div>
	);
};

export default UltraproxyPageTemplate;

const HowItWorksSection = ({ translations }) => (
	<section className="flex text-black flex-col gap-20 xl:flex-row xl:gap-0 text-left items-center container mx-auto">
		<div className="w-full xl:w-1/2 flex flex-col gap-10">
			<StyledTitle
				titleColor="text-ipxonBlack"
				titleSize="text-3xl"
				titleText={translations["UltraproxyHowItWorksTitle"]}
				subtitleText={translations["UltraproxyHowItWorksSmallTitle"]}
				labelText=""
			/>
			<ul className="flex flex-col gap-4">
				{howItWorksInfo.map((howItWorksItem) => (
					<li
						key={howItWorksItem.title}
						className="flex flex-col border border-gray-200 rounded-lg px-[40px] py-[20px] max-w-[550px] text-base"
					>
						<h4 className="font-bold uppercase text-base">{translations[howItWorksItem.title]}</h4>
						<p>{translations[howItWorksItem.description1]}</p>
						<p>{translations[howItWorksItem.description2]}</p>
					</li>
				))}
			</ul>

			<div className="mt-4">
				<p className="mb-6">
					<span className="text-ipxon-magenta">*(1)</span> {translations["UltraproxyHowItWorksBulletOne"]}
				</p>
				<p>
					<span className="text-ipxon-magenta">*(2)</span> {translations["UltraproxyHowItWorksBulletTwo"]}
				</p>
			</div>
			{/* <div className="w-full text-left">
				<PrimaryOutlineButton
					onClick={() => {
						navigate("#UltraproxyInputSection");
					}}
				>
					{translations["UltraproxyHowItWorksButtonText"]}
				</PrimaryOutlineButton>
			</div> */}
		</div>
		<div className="w-full xl:w-1/2 items-center flex flex-col gap-8 ">
			<img className="w-2/3 xl:ml-auto" src={imageUltraproxy} alt="Ultraproxy Diagram" />
		</div>
	</section>
);
